define([
    './services/QuickQuoteService',
    './directives/QuickStepProgress',
    'integration/quoteandbind/quickquote/directives/QuickQuoteLink'
], (QuickQuoteService, QuickStepProgress, QuickQuoteLink)=> {

    return angular.module('edge.quoteandbind.quickquote.common.app', [])
        .factory('quickquote.QuickQuoteService', QuickQuoteService)
        .directive('gwQuickStepProgress', QuickStepProgress)
        .directive('gwQuickQuoteLink', QuickQuoteLink);
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/common/app.js
 **/